<template>
  <div>
    <div class="trim-name py-4">
      <div class="container-wrapper">
        <h2 class="mb-1">{{ selectedModelName }}</h2>
        <div class="font-weight-bold">{{ trimDetailsName }}</div>
        <div class="transmission">{{ $t(`message.buildAndPrice.transmission.${trimDetails.transmission}`) }}</div>
      </div>
    </div>
    <div class="container-wrapper my-4">
      <div class="key-features">
        <div v-for="keyFeature in keyFeatures" :key="keyFeature">
          <template v-if="trimDetails.keyFeatures[keyFeature]">
            <div class="font-weight-bold mb-2">{{ $t(`message.buildAndPrice.keyFeatures.${keyFeature}`) }}</div>
            <ul>
              <li v-for="(item, index) in trimDetails.keyFeatures[keyFeature]" :key="index">{{ item }}</li>
            </ul>
          </template>
        </div>
      </div>
      <div class="pb-4 pt-3">
        <mobialis-button
          @click="selectTrim(trimDetails.id)"
          :class="{ active: selectedTrimId === trimDetails.id }"
          :aria-pressed="selectedTrimId === trimDetails.id"
          size="btn-md"
          variant="secondary"
        >
          {{
            selectedTrimId === trimDetails.id
              ? $t('message.buildAndPrice.trimSelect.selected')
              : $t('message.buildAndPrice.trimSelect.select')
          }}
          <span class="checkmark-icon primary-fill-svg">
            <svg xmlns="http://www.w3.org/2000/svg" class="info" width="20" height="20" viewBox="0 0 20 20">
              <path
                fill="#007bc7"
                fill-rule="evenodd"
                d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-8.925 4.236L15.01 8.3a.516.516 0 0 0 0-.73l-.73-.73a.516.516 0 0 0-.73 0l-4.84 4.841-2.26-2.26a.516.516 0 0 0-.73 0l-.73.73a.516.516 0 0 0 0 .73l3.355 3.355a.516.516 0 0 0 .73 0z"
              ></path>
            </svg>
          </span>
        </mobialis-button>
        <mobialis-button @click="$router.push('trim-select')" size="btn-md" variant="link">{{
          $t('message.buildAndPrice.trimSelect.back')
        }}</mobialis-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'TrimDetails',
  data() {
    return {
      keyFeatures: ['wheels', 'entertainment', 'interiorSafety'],
    };
  },
  computed: {
    ...mapState('buildAndPrice', ['selectedTrimId']),
    ...mapGetters({
      viewTrimDetails: 'buildAndPrice/viewTrimDetails',
      selectedModelName: 'buildAndPrice/selectedModelName',
    }),
    trimDetails() {
      return this.viewTrimDetails.vehicle;
    },
    trimDetailsName() {
      return `${this.trimDetails.trim} ${this.trimDetails.style}`;
    },
  },
  methods: {
    async selectTrim(value) {
      try {
        if (value !== this.selectedTrimId) {
          this.$store.commit('buildAndPrice/SET_STATE', ['selectedTrimId', value]);
          this.$store.commit('buildAndPrice/RESET_SELECTED_OPTIONS');
          await this.$store.dispatch('buildAndPrice/getBuildAndPriceConfig', value);
        }
        this.$router.push('colours-select');
      } catch (e) {
        this.$router.push('error');
        this.$log('Error getting build and price configuration', e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';

.trim-name {
  background: #f0f4f7;
  h2 {
    color: #4b5863;
    font-size: 14px;
    line-height: 18px;
  }
  .transmission {
    color: #4b5863;
    font-size: 10px;
    line-height: 18px;
  }
}

.key-features {
  font-size: 14px;
  line-height: 18px;
  ul {
    font-size: 12px;
    line-height: 18px;
    padding-left: 20px;
    li {
      margin-bottom: 5px;
    }
  }
}

// -- selected button styling

button.btn-secondary::v-deep {
  .checkmark-icon {
    display: none;
  }
}

button.btn-secondary:not(:disabled):not(.disabled).active::v-deep {
  background: $primary-light-background;
  border: 1px solid $primary;
  color: #19222b;
  position: relative;
  .checkmark-icon {
    display: block;
    position: absolute;
    right: 10px;
    top: 5px;
  }
}
</style>
